import Vue from 'vue'
import Router from 'vue-router'

import Login from './views/Login.vue'
import Admin from './views/Admin.vue'
import Error from './views/Error.vue'

import Sites from './views/sites/Sites.vue'
import SiteContainer from './views/sites/SiteContainer.vue'
import Site from './views/sites/Site.vue'
import SiteCreate from './views/sites/SiteCreate.vue'
import SiteEdit from './views/sites/SiteEdit.vue'

import AnalyticsContainer from './views/analytics/Container.vue'
import AnalyticsAnalytics from './views/analytics/Analytics.vue'

import SettingsContainer from './views/settings/Container.vue'
import Billing from './views/settings/Billing.vue'
import Users from './views/settings/Users.vue'

import SocialContainer from './views/social/Container.vue'
import SocialAccounts from './views/social/Accounts.vue'

import DesignContainer from './views/design/Container.vue'
import DesignColours from './views/design/Colours.vue'
import DesignStyles from './views/design/Styles.vue'
import DesignLogo from './views/design/Logo.vue'

import WebsiteContainer from './views/website/Container.vue'
import WebsiteDomains from './views/website/Domains.vue'

import EntriesContainer from './views/entries/Container.vue'
import Entries from './views/entries/Entries.vue'
import EntryEdit from './views/entries/EntryEdit.vue'
import EntryPage from './views/entries/EntryPage.vue'
import EntryPageSettings from './views/entries/EntryPageSettings.vue'
import FormResults from './views/entries/FormResults.vue'

import LinksContainer from './views/links/Container.vue'
import LinksLinks from './views/links/Links.vue'

import ContentContainer from './views/content/Container.vue'
import ContentCopy from './views/content/Copy.vue'
import ContentAuto from './views/content/Auto.vue'
import ContentKeywords from './views/content/Keywords.vue'

import Locations from './views/links/locations/Locations.vue'
import Location from './views/links/locations/Location.vue'
import LocationCreate from './views/links/locations/LocationCreate.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {path: '/', name: 'home', component: Login},
    {path: '/login', name: 'login', component: Login},
    {path: '/admin', name: 'admin', component: Admin},
    {path: '/sites', name: 'sites', component: Sites},
    {path: '/site', name: 'site_create', component: SiteCreate},
    {
      path: '/site/:site_id', component: SiteContainer, children: [
        {path: '', name: 'site', component: Site},
        {
          path: 'design', component: DesignContainer, children: [
            {path: 'colours', name: 'colours', component: DesignColours},
            {path: 'styles', name: 'styles', component: DesignStyles},
            {path: 'logo', name: 'logo', component: DesignLogo},
          ]
        },
        {
          path: 'website', component: WebsiteContainer, children: [
            {path: '', name: 'domains', component: WebsiteDomains},
          ]
        },
        {
          path: 'entries', component: EntriesContainer, children: [
            {path: '', name: 'entries', component: Entries},
            {path: 'singles', name: 'singles', component: Entries, meta: {entry_type: 'singles'}},
            {path: 'blogs', name: 'blogs', component: Entries, meta: {entry_type: 'blogs'}},
            {path: 'services', name: 'services', component: Entries, meta: {entry_type: 'services'}},
            {path: 'testimonials', name: 'testimonials', component: Entries, meta: {entry_type: 'testimonials'}},
            {path: 'awards', name: 'awards', component: Entries, meta: {entry_type: 'awards'}},
            {path: 'forms', name: 'forms', component: Entries, meta: {entry_type: 'forms'}},
            {path: 'form_results', name: 'form_results', component: FormResults, meta: {entry_type: 'forms'}},
          ]
        },
        {
          path: 'entries/:id', component: EntryEdit, meta: {hide_sidebar: true}, children: [
            {path: 'page', name: 'entry_page', component: EntryPage, meta: {hide_sidebar: true}},
            {path: 'settings', name: 'entry_page_settings', component: EntryPageSettings, meta: {hide_sidebar: true}},
          ]
        },
        {
          path: 'content', component: ContentContainer, children: [
            {path: 'copy', name: 'content_copy', component: ContentCopy},
            {path: 'auto', name: 'content_auto', component: ContentAuto},
            {path: 'keywords', name: 'keywords', component: ContentKeywords},
          ]
        },
        {
          path: 'links', component: LinksContainer, children: [
            {path: 'links', name: 'site_links', component: LinksLinks},
            {path: 'locations', name: 'locations', component: Locations},
            {path: 'location', name: 'location_create', component: LocationCreate},
            {path: 'location/:id', name: 'location', component: Location},
          ]
        },
        {
          path: 'settings', component: SettingsContainer, children: [
            {path: 'site', name: 'site_edit', component: SiteEdit},
            {path: 'billing', name: 'billing', component: Billing},
            {path: 'users', name: 'users', component: Users},
          ]
        },
        {
          path: 'social', component: SocialContainer, children: [
            {path: 'accounts', name: 'social_accounts', component: SocialAccounts}
          ]
        },
        {
          path: 'analytics', component: AnalyticsContainer, children: [
            {path: 'analytics', name: 'site_analytics', component: AnalyticsAnalytics},
          ]
        },
      ]
    },
    {path: '*', component: Error}
  ]
})
